import { TRANSACTIONS_TAB_PARAM } from "./transaction-details";

// Order matches the tabs in GestionFinancials; the names are what ?tab= accepts.
export const FINANCIALS_TABS = ["general", TRANSACTIONS_TAB_PARAM, "prices", "membership"];

export const financialsTabFromSearch = (search) => {
  const index = FINANCIALS_TABS.indexOf(new URLSearchParams(search || "").get("tab"));
  return index >= 0 ? index : 0;
};
